import {
    CLIENT_NAME,
    FILING,
    UNDERSCORE
} from "../../../common/constants/constants";
import {processFilingAsyncRequest, submitFilingRequestAsync} from "../utils/filingAPIs";
import {filingRequestAsyncUseCaseList, TRANSMIT_FILE_ASYNC} from "../utils/Constants";

export const handleFiling = (passedData, filingDispatcher, params, additionalParams = {}) => {
    const additionalDataMap = Object.assign({
        ExcaliburTransformationId: passedData.transactionId
    }, additionalParams);

    //TODO: This conditional calling will be removed once all useCases of API transmitFileAsync will be migrated to filingRequestAsync
    const subUseCase = passedData.subUseCase + UNDERSCORE + FILING
    if(filingRequestAsyncUseCaseList.includes(passedData.useCase + UNDERSCORE + subUseCase)) {
        const filingObj = {
            "useCase": passedData.useCase,
            "clientName": CLIENT_NAME,
            "operationType": TRANSMIT_FILE_ASYNC,
            "subUseCase": subUseCase,
            "additionalDataMap": additionalDataMap
        }
        processFilingAsyncRequest(filingDispatcher, filingObj, () => {
        })
    } else {
        const filingObj = {
            "useCase": passedData.useCase,
            "clientName": CLIENT_NAME,
            "subUseCase": subUseCase,
            "s3BucketName": passedData.inputFileBucket,
            "s3FolderPath": passedData.inputFileKey,
            "additionalDataMap": additionalDataMap
        }
        submitFilingRequestAsync(filingDispatcher, filingObj, () => {
        })
    }

}